import JobApplication from ".";
import UserJobApplication from "./UserJobApplication.js";
import UserSavedJobs from "./UserSavedJobs.js";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ApplicationDetails from "./ApplicationDetails";
const tabRoutes = [
  {
    label: "Applications",
    icon: "fa-regular fa-paper-plane",
    path: "/admin/job-applications",
  },
];

export const jobsApplicationRoutes = () => [
  {
    path: "/admin/job-applications",
    component: () => (
      <>
        {/* <TabsNavigation title="Jobs Applications" tabRoutes={tabRoutes}>
          <JobApplication />
        </TabsNavigation> */}
        <div className="space-y-4 w-full flex flex-col pb-10">
          <div className="space-y-2 xls:space-y-6">
            <div className="text-lg xls:text-3xl text-bunker font-semibold">
              Jobs Applications
            </div>
            <JobApplication />
          </div>
        </div>
      </>
    ),
    layout: "admin",
    // routeType: "admin",
    title: "Jobs Applications",
  },
  {
    path: `/admin/application-view/:applicationId`,
    component: ApplicationDetails,
    layout: "admin",
    // routeType: "admin",
    title: "Application View",
  },

  {
    path: "/job-applications",
    component: () => (
      <>
        {/* <TabsNavigation title="Jobs Applications" tabRoutes={tabRoutes}>
          <JobApplication />
        </TabsNavigation> */}
        <div className="space-y-4 w-full flex flex-col pb-10">
          <div className="space-y-2 xls:space-y-6">
            <div className="text-lg xls:text-3xl text-bunker font-semibold">
              Jobs Applications
            </div>
            <UserJobApplication />
          </div>
        </div>
      </>
    ),
    layout: "admin",
    routeType: "user",
    title: "Jobs Applications",
  },
  {
    path: "/saved-jobs",
    component: () => (
      <>
        <div className="space-y-4 w-full flex flex-col pb-10">
          <div className="space-y-2 xls:space-y-6">
            <div className="text-lg xls:text-3xl text-bunker font-semibold">
              Saved Jobs
            </div>
            <UserSavedJobs />
          </div>
        </div>
      </>
    ),
    layout: "admin",
    routeType: "user",
    title: "Saved Jobs",
  },
];
